<template>
  <div>
    <header class="header" style="background-color:#000000;">
      <template v-if="showOrNot !== 'not'">
        <!--<symbol id="icon-cart" viewBox="0 0 38 32">-->
          <title>cart</title>
          <!--<path class="path1"
                d="M37.759 0h-4.133c-0.733 0.004-1.337 0.549-1.434 1.255l-0.546 4.342c-0.081 0.484-0.496 0.849-0.997 0.849-0.005 0-0.009-0-0.014-0h-27.604c-0.003 0-0.007-0-0.011-0-1.674 0-3.031 1.357-3.031 3.031 0 0.34 0.056 0.666 0.159 0.971l2.52 8.062c0.385 1.194 1.486 2.043 2.785 2.043 0.126 0 0.25-0.008 0.372-0.023l22.983 0.002c0.515 0.131 0.626 0.768 0.626 1.283 0.005 0.044 0.009 0.095 0.009 0.146 0 0.501-0.294 0.933-0.718 1.134l-22.439 0.003c-0.354 0-0.642 0.287-0.642 0.642s0.287 0.642 0.642 0.642h22.745l0.131-0.071c0.919-0.392 1.551-1.287 1.551-2.33 0-0.058-0.002-0.116-0.006-0.173 0.021-0.108 0.033-0.24 0.033-0.376 0-1.072-0.732-1.973-1.724-2.23l-23.357-0.004c-0.063 0.008-0.135 0.013-0.209 0.013-0.719 0-1.332-0.455-1.566-1.093l-2.53-8.095c-0.048-0.154-0.076-0.332-0.076-0.515 0-0.973 0.782-1.764 1.752-1.778h27.657c1.159-0.004 2.112-0.883 2.232-2.011l0.547-4.345c0.010-0.083 0.078-0.147 0.161-0.152l4.133-0c0.354 0 0.642-0.287 0.642-0.642s-0.287-0.642-0.642-0.642z"></path>
          <path class="path2"
                d="M31.323 9.69c-0.022-0.003-0.048-0.004-0.074-0.004-0.328 0-0.598 0.248-0.633 0.567l-0.809 7.268c-0.003 0.022-0.004 0.048-0.004 0.074 0 0.328 0.248 0.598 0.567 0.633l0.074 0c0.001 0 0.003 0 0.004 0 0.327 0 0.596-0.246 0.632-0.563l0.809-7.268c0.003-0.022 0.004-0.048 0.004-0.074 0-0.328-0.248-0.598-0.567-0.633z"></path>
          <path class="path3"
                d="M27.514 25.594c-1.769 0-3.203 1.434-3.203 3.203s1.434 3.203 3.203 3.203c1.769 0 3.203-1.434 3.203-3.203s-1.434-3.203-3.203-3.203zM27.514 30.717c-1.060 0-1.92-0.86-1.92-1.92s0.86-1.92 1.92-1.92c1.060 0 1.92 0.86 1.92 1.92s-0.86 1.92-1.92 1.92z"></path>
          <path class="path4"
                d="M9.599 25.594c-1.769 0-3.203 1.434-3.203 3.203s1.434 3.203 3.203 3.203c1.769 0 3.203-1.434 3.203-3.203s-1.434-3.203-3.203-3.203zM9.599 30.717c-1.060 0-1.92-0.86-1.92-1.92s0.86-1.92 1.92-1.92c1.060 0 1.92 0.86 1.92 1.92s-0.86 1.92-1.92 1.92z"></path>
        </symbol>-->


        <div :class="['navbar','navbar_pc',showNavbar?'showNavbar':'']">
          <div class="navbar-left-container">
              <a id="home" class="home" @click="toHome" v-if="!providerId || showCart">首页</a>
              <img class="" src="../../static/user.png" width="16" height="16" alt="检验网icon-user"  style="margin-left:15px;">
              <router-link :to="user.isChannel == 2 ? '/mine/sampleManage' : '/mine/myReport'" class="navbar-link hideel" v-text="'个人中心 > '+nickName"
                           v-if="nickName"></router-link>
            <a href="javascript:void(0)" class="navbar-link" @click="showLoginModal" v-if='!nickName'>登录</a>
            <a href="javascript:void(0)" class="navbar-link out" @click='centerDialogVisible = true'
               v-if="nickName">退出</a>


          </div>
          <!-- 推广码进入 hasPcKey true 不显示 -->
          <div :class="['navbar-right-container', providerId?'navbar-cart-pro':'', showCart?'showCart':'']" style="display: flex;" v-show="!hasPcKey">
                <a href="javascript:void(0)"  @click="toCart" style="display:flex;">
                  <el-badge :value="cartCount" :max="9999" :hidden="cartCount == 0 || !nickName" class="item" style="display:flex;align-items: flex-end">
                    <img class="navbar-link" src="../../static/cart.png" style="height: 16px;" alt="检验网icon-cart">
                  </el-badge>
                  <span class="navbar-link">购物车</span>
                </a>

                <!--<span class="navbar-cart-count" v-if="cartCount>0">{{cartCount}}</span>-->
                <!--<a class="navbar-link " href="/#/cart">-->
                  <!--<svg class="navbar-cart-logo">-->
                    <!--<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-cart"></use>-->
                  <!--</svg>-->
                <!--</a>-->
          </div>
          <!-- 领券中心 -->
          <div style="margin-left:5px;display:flex;align-items: center" v-if="IsPC()">
            <svg style="height:16px;width: 16px;" t="1592286416537" class="icon" viewBox="0 0 1280 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8700" width="18" height="18"><path d="M608.00128 544h-128a32 32 0 0 0 0 64h128V704a32 32 0 0 0 64 0V608h128a32 32 0 0 0 0-64h-128v-64h128a32 32 0 0 0 0-64h-114.752l105.408-105.344a32 32 0 1 0-45.312-45.312L640.00128 370.752 534.65728 265.344a32 32 0 1 0-45.312 45.312L594.75328 416H480.00128a32 32 0 0 0 0 64h128v64z m609.152 149.248c34.688 5.952 62.848 39.104 62.848 75.328V960c0 35.392-29.12 64.064-63.488 64.064H63.48928A63.616 63.616 0 0 1 0.00128 960v-191.36c0-35.712 28.352-67.392 62.848-75.392C62.84928 693.248 192.00128 704 192.00128 512S62.84928 330.752 62.84928 330.752C28.16128 324.8 0.00128 291.648 0.00128 255.424V64C0.00128 28.672 29.12128 0 63.48928 0h1153.024c35.072 0 63.488 28.48 63.488 64v191.36c0 35.712-28.352 67.392-62.848 75.392C1217.15328 330.752 1088.00128 320 1088.00128 512s129.152 181.248 129.152 181.248z" p-id="8701" fill="#17B3A3"></path></svg>
            <router-link to='/couponsCenter' style="vertical-align:top;padding-left: 8px;">领券中心</router-link>
          </div>
        </div>
        <div class="center" v-if="showSearch">
          <div class="navbar2">
            <h1 class="navbar-left-container2" v-if="!providerId">
              <img src="../assets/logo.png" width="135" height="41" @click="toHome" class="search-icon" alt="检验网 基因检测 医学检查">
            </h1>
            <div :class="['navbar-right-container2', providerId?'navbar-search-pro':'']">
              <div class="search-bar clearfix">
                <input class="search-input" type="text" placeholder="搜索商品..."  v-model="keywords"  @keyup.enter="toGoodsList">
                <button class="search-btn" @click="toGoodsList">搜索</button>
                <img src="../../static/search.png" class="search-icon" alt="检验网icon-search">
              </div>
            </div>
          </div>
        </div>
        <div>
          <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"

            center>
            <span>确定要退出吗?</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="centerDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="logout">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </template>
      <div class="md-modal modal-msg md-modal-transition" v-bind:class="{'md-show':loginModalFlag}">
            <!-- <div class="md-modal-inner" v-if="loginType === 'username'">
              <div class="md-top">
                <div class="md-change-login" >
                  <span  class="password-login select" >密码登录</span>
                  <span>|</span>
                  <span class @click="changeLogin">验证码登录</span>
                </div>
                <button class="md-close" @click='closeLoginModal'>Close</button>
              </div>
              <div class="md-content">
                <div class="confirm-tips" >
                  <ul style="position: relative">
                    <li class="regi_form_input">
                      <i class="icon IconPeople"></i>
                      <input type="text" tabindex="1" name="username" v-model="username" class="regi_login_input"
                             placeholder="请输入用户名">
                    </li>
                    <li class="regi_form_input">
                      <i class="icon IconPeople"></i>
                      <input type="text" tabindex="2" name="password" v-model="password" class="regi_login_input"
                             placeholder="请输入登录密码">
                    </li>
                     <li class="regi_form_input">
                      <i class="icon IconPeople"></i>
                      <input type="number" tabindex="3" name="captcha" v-model="captcha" class="regi_login_input"
                      placeholder="请输入验证码"  @keyup.enter="nameLogin">
                      <div class="userlogin-captcha el-col el-col-9"  ><img :src="imgUrl" @click="changeImg" style="height:42px; width:118px; display:block"   alt="" title="点击更换"></div>
                  </li>
                  </ul>

                </div>
                <div class="login-wrap">
                  <span href="javascript:;" class="btn-login" @click='nameLogin'>登 录</span>
                </div>
              </div>
            </div> -->
             <div class="md-modal-inner"  >
              <div class="md-top">
                <div class="md-change-login" >
                  <!-- <span  class @click="changeLogin">密码登录</span>
                  <span>|</span> -->
                  <span  class="password-login select" >验证码登录</span>
                </div>
                <p class="md-change-tip">验证即登录， 未注册手机号将自动为您创建账号</p>
                <button class="md-close" @click='closeLoginModal'>Close</button>
              </div>
              <div class="md-content">
                <div class="confirm-tips">
                  <ul style="position: relative">
                    <li class="regi_form_input">
                      <i class="icon IconPeople"></i>
                      <input type="text" maxlength="11" tabindex="1" name="loginname" v-model="mobile" class="regi_login_input"
                             placeholder="请输入手机号">
                    </li>
                    <li class="regi_form_input noMargin" style="width:80%;border-right:none;">
                      <i class="icon IconPwd"></i>
                      <input type="text" tabindex="2" name="captcha" v-model="captcha" class="regi_login_input"
                             placeholder="请输入验证码" @keyup.enter="login" maxlength="6">
                    </li>
                    <button v-if="sending" class="btn-code" @click="getVerificationCode">获取验证码</button>
                    <button v-else class="btn-code">{{second}}秒后重发</button>
                  </ul>
                </div>
                <div class="loginTip">点击登录即代表您同意<a style="color: #00C4AA;" @click="showTip()">《检验网隐私政策》</a></div>
                <div class="login-wrap">
                  <a href="javascript:;" class="btn-login" @click='login'>登 录</a>
                </div>
              </div>
            </div>
          </div>
          <div class='md-overlay' v-if="loginModalFlag" @click='closeLoginModal'></div>
    </header>

    <!--协议信息弹框-->
    <privacy-detail v-if="privacyDetailVisible" ref="privacyDetail"></privacy-detail>

    <!-- 图片验证码弹框 -->
    <captcha-modal
      :visible.sync="captchaModalVisible"
      @validate-success="onCaptchaValidateSuccess">
    </captcha-modal>
  </div>
</template>


<script>
  import './../assets/css/login.css'
  import './../assets/css/base.css'
  import PrivacyDetail from '../components/privacy-detail'
  import CaptchaModal from '../components/CaptchaModal'
  import {getCookie, setCookie, delCookie, removeHTMLTag, isValidPhone,isValidLoginName,isValidPassword, IsPC} from '@/util/util.js'
  import axios from 'axios'

  export default {
    props:["showSearch","loginModalFlag","showOrNot","showNavbar","showCart"],
    inject:['reload'],
    data() {
      return {
        centerDialogVisible: false,
        mobile: '',
        captcha: '',
        regex: /^\d{6}$/,
        errorTip: false,
        // loginModalFlag: false,
        //nickName: '',
        myuuid: '',
        // 登录信息
        timer: '',
        sending: true,
        second: 60,
        loginType:'username',
        username:'',
        password:'',
        imgUrl:'http://192.168.10.212:8090/hpv/captcha.jpg?uuid='+this.myuuid,
        keywords:'',
        hasPcKey: getCookie("pc") ? true : false,  // 推广扫码标识
        providerId: this.$store.state.providerId || localStorage.getItem("providerId") || '',
        cartCount: this.$store.state.cartCount,
        privacyDetailVisible: false,
        // 图片验证码弹框可见性
        captchaModalVisible: false
      }
    },
    components: {
      PrivacyDetail,
      CaptchaModal
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      nickName() {
        return this.$store.state.nickName;
      },
    },
    watch: {
      '$store.state.providerId': function(val) {
        this.providerId = val
        this.getCartCount()
      },
      '$store.state.cartCount': function(val) {
        this.cartCount = val
      },
      'loginModalFlag': function(val) {
        if (val) {
          window.scroll(0, 0)
        }
      }
    },
    mounted() {
      this.checkLogin()
      this.getUuid()
      //  var storage = window.localStorage;
      //   storage.clear()
    },
    methods: {
      IsPC() {
        let userAgentInfo = navigator.userAgent;
        let Agents = ["Android", "iPhone",
          "SymbianOS", "Windows Phone",
          "iPad", "iPod"];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag
      },
      showLoginModal(){
        this.$emit("showLoginModal")
      },
      toHome(){
        this.providerId?this.$router.push({path: "/company/index", query: {id: this.providerId}}):this.$router.push('/')
      },
      // 切换登录方式
      changeLogin() {
        if(this.loginType=='username'){
          this.loginType='mobile'
        }else{
          this.loginType='username'
        }
      },
      closeLoginModal(){
        this.captcha = ""
        this.$emit("closeLoginModal")
      },
      checkLogin() {
        if (getCookie("_token")) {
          this.getUserInfo()
          this.getCartCount()
        } else {
          // this.$message({
          //   showClose: true,
          //   message: '登录信息失效,请重新登录',
          //   type: 'error'
          // });
          this.$store.commit("updateNickName", '');
          this.$store.commit("updateUserInfo",{})
          delCookie("_token")
          delCookie("userId")
          // delCookie("pc")
        }
      },
      uuid: function () {
        function S4() {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }

        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
      },
      getUuid() {
        this.myuuid = this.uuid()
      },
      //点击获取验证码
      getVerificationCode() {
        if (!this.mobile) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入正确的手机号'),
            type: 'error'
          });
          return false;
        }
        if (!isValidPhone(this.mobile)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('手机号不正确'),
            type: 'error'
          });
          return false;
        }
        // 显示图片验证码弹框
        this.captchaModalVisible = true;
      },

      // 图片验证码验证成功回调
      onCaptchaValidateSuccess(uuid) {
        // 验证成功后获取短信验证码
        this.getCode(uuid);
      },
      getCode: function (uuid) {
        this.sending = false;
        this.second = 60;
        this.timer =  setInterval(()=>{
          this.second--;
          if(this.second<=0){
            this.sending = true;
            clearInterval(this.timer);
          }
        }, 1000);
        axios.get("/hpv/captcha-sms/" + this.mobile + '/' + uuid, {
          params: {
            platform: 1,
          }
        }).then((response) => {
          if (response.data.code == 0) {
            // console("获取成功")
          }
        })
      },
      search(){
        console.log("点击搜索")
      },
      // 手机验证码登录
      login() {
        //校验用户名和密码
        if (!this.mobile) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入正确的手机号'),
            type: 'error'
          });
          return false;
        }
        if (!isValidPhone(this.mobile)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('手机号不正确'),
            type: 'error'
          });
          return false;
        }
        if(!this.regex.test(this.captcha)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入正确的验证码'),
            type: 'error'
          });
          return false;
        }
        axios.post("/hpv/login", {
          mobile: this.mobile,
          captcha: this.captcha
        }).then((response) => {
          console.log(response)
          let res = response.data;
          if (res.code == 0) {
            // this.errorTip = false;
            this.$emit("closeLoginModal")
            this.expire = res.expire
            // console.log(res.token)
            // console.log(res.expire)

            setCookie('_token', res.token)
            // console.log(allCookie())
            // this.$store.commit("updateToken",res.token);
            this.getUserInfo();
            this.getCartCount();
            // this.reload()


          } else if (res.msg == '手机号未注册') {
            this.regist()
          }

        })

      },
      // 用户名密码登录
      nameLogin(){
        //校验用户名
        if (!this.username) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入用户名'),
            type: 'error'
          });
          return false;
        }
        if (!isValidLoginName(this.username)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('用户名不正确'),
            type: 'error'
          });
          return false;
        }
        // 校验密码
        if (!this.password) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('请输入密码'),
            type: 'error'
          });
          return false;
        }
        if (!isValidPassword(this.password)) {
          this.$message({
            showClose: true,
            message: removeHTMLTag('密码不正确'),
            type: 'error'
          });
          return false;
        }
        axios.post("/hpv/loginByUsername", {
          username: this.username,
          password: this.password,
          captcha: this.captcha,
          uuid:this.myuuid
        }).then((response) => {
          console.log(response)
          this.reload()

          // let res = response.data;
          // if(res.code == 500){
          //   this.$message({
          //     message:"密码不能为空",
          //     type:"error"
          //   })
          // }

        })
      },
      // 获取图片验证码
      changeImg(){
        axios.get("/hpv/captcha.jpg",{
          params:{
            uuid: this.myuuid
          }
        }).then(res => {
          var num=Math.ceil(Math.random()*10);
          this.imgUrl ="http://192.168.10.212:8090/hpv/captcha.jpg?uuid=" + num
        })
      },
      getUserInfo() {
        // console.log(getCookie("_token"))
        axios.get("/hpv/user/me/1", {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          let res = response.data;
          if (res.code == 0) {
            let user = res.user
            user.gender = user.sex == 0 ? "女" : "男"
            let nickName = user.name
            setCookie('userId', user.userId)
            this.$store.commit("updateNickName", nickName);
            this.$store.commit("updateUserInfo",user)

          } else if (res.code == 401) {
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
          }

        })
      },

      regist() {
        axios.post("/hpv/register", {
          mobile: this.mobile,
          captcha: this.captcha
        }).then((response) => {
          let res = response.data
          if (res.code == 0) {
            // this.errorTip = false;
            this.$emit("closeLoginModal")
            this.expire = res.expire
            // console.log(res.token)
            // console.log(res.expire)

            setCookie('_token', res.token)
            // console.log(allCookie())
            // this.$store.commit("updateToken",res.token);
            this.getUserInfo();
            this.getCartCount();

          }
        })
      },

      logout() {
        this.mobile = ""
        this.captcha = ""
        this.centerDialogVisible = false
        this.$store.commit("updateNickName", '');
        this.$store.commit("updateUserInfo",{})
        this.$store.commit("updateCartCount",0)
        delCookie("_token")
        delCookie("userId")
        delCookie("pc")
        this.$emit("showLoginModal")
        //回到首页
        this.providerId?this.$router.push({path: "/company/index", query: {id: this.providerId}}):this.$router.push('/')
      },

      toGoodsList(){
       this.$router.push({path: "/goodsList", query: {params:this.keywords}})
      },

      toCart(){
        if(getCookie("_token")){
          this.$router.push("/cart")
        }else{
          this.$message.error("您还没有登录哦")
          this.$emit("showLoginModal")
        }
      },

      getCartCount(){
        axios.get("/jys/cart?shopId=" + this.providerId, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token"),
            "pcKey": getCookie("pc"),
          }
        }).then((response) => {
          let res = response.data
          let cartCount = 0
          if (res.code == 0) {
            let itemList = res.itemList
            if(itemList != null){
              for(var i = 0 ; i < itemList.length; i++){
                cartCount += itemList[i].number
              }
              this.$store.commit("updateCartCount",cartCount);
            }else{
              this.$store.commit("updateCartCount",0);
            }
          }
        })
      },

      showTip() {
        this.privacyDetailVisible = true
        this.$nextTick(() => {
          this.$refs.privacyDetail.init()
        })
      }
    }
  }
</script>
<style scoped>
.hideel {
  white-space: nowrap;
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.about_us {
  display: inline;
  opacity: 0;
}

.btn-code {
    width: 20%;
    border: 1px solid #00C5B0;
    color: #00C5B0;
    height: 42px;
    line-height: 42px;
    position: absolute;
    bottom: 0px;
    right: 0px;
}

.el-button--primary {
    background-color: #00C5B0;
    border-color: #00C5B0;
}

.el-button--primary:hover {
    background-color: #00C5B0;
    border-color: #00C5B0;
}

.el-dialog--center .el-dialog__body {
    text-align: center;
}

.el-button--default:hover {
    border-color: #00C5B0;
    color: #00C5B0;
    background-color: #fff;
}

/*角标*/
.el-badge__content {
    background-color: #00C5B0;
    color: #fff;
    border: none;
}

.el-badge__content.is-fixed {
    right: -7px;
    top: 9px;
}

/*搜索框*/
.search-bar {
    width: 294px;
    heigth: 40px;
}

.search-bar .search-input {
    width: 781px;
    height: 40px;
    font-size: 14px;
    margin: 0;
    border-right: none;
    position: absolute;
    top: 20px;
    left: -20px;
    border-radius: 5px 0 0 5px;
    padding: 0 40px;
}

input::-ms-clear {
    display: none;
}

input[type='text'],
input[type='number'],
input[type='password'],
textarea {
    padding: 0
}

.search-bar .search-btn {
    width: 87px;
    background-color: #00C5B0;
    color: #ffffff;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    border-left: none;
    position: absolute;
    top: 20px;
    border-radius: 0 5px 5px 0;
    right: 20px;
}

.search-bar .search-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 33px;
    left: 0px;
}

.navbar-right-container2 {
    width: 868px;
    margin: 0 auto;
    position: relative;
}

.navbar-left-container2 {
    width: 200px;
    position: absolute;
    left: 67px;
    top: 20px;
}

.navbar2 {
    max-width: 100%;
    position: relative;
}
.md-change-login {
width: 435px;cursor: pointer;
height: 45px;
font-size: 22px;
text-align: center;

}
.md-change-login a {
color: #aaa;
text-align: center;
width: 200px;
display: inline-block;
}
.md-change-login span {
color: #cccccc;
}
.md-change-login .select {
/* border-bottom: 2px solid #bbb; */
color: #00C5B0;
}
.userlogin-captcha {
float: right;
width: 118px;
height:42px;
}
.md-change-tip {
color: #bbb;
font-size: 12px;
text-align: center;
height: 25px;
line-height: 20px;
}
.md-modal .md-modal-inner {
padding-top: 50px;
}
/deep/ .el-badge__content.is-fixed {
    top: -9px;
    right: 12px;
  }
 /deep/ .navbar-left-container .home{
   display: none!important;
 }
 .out{
   margin:0 0 0 5px;
 }
 .navbar_pc{
   display: flex;
 }
.loginTip {
  font-size: 12px;
  padding: 10px 0 0 0;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .header .navbar {
    right: 60px;
  }
  #special_head .header .navbar {
    right: 20px;
  }
  .navbar_pc{
    display: none;
  }
  .showNavbar{
    display: flex;
  }
  .regi_form_input .icon {
    width: 0;
  }
    .navbar-right-container2 {
       width: 266px;
       margin: 0 0 0 120px;
    }
  .md-change-tip{
    line-height: 40px;}
    .navbar-left-container2 img {
        width: 90px;
        height: 27px;
        margin-top: 6px;
    }

    .search-bar .search-icon{
        left: 14px;
    }

    .search-bar .search-input{
        width: 173px;
        left: 0;
    }
    .navbar-cart-container {
     margin-right: 0;
    }
    .search-bar .search-input {
        width: 181px;
    }
    .md-change-login {
        height: 40px;
        display: flex;    line-height: 50px;
        width:inherit;

        justify-content:space-around;
        font-size: 16px;
    }
    .md-change-login a{
      width: 30%;font-size: 14px;
      line-height: 40px;
    }

    .btn-code{
      font-size: 12px;
          width: 26%;
          height: 35px;
          line-height: 35px;
    }
    .navbar{
      /*right: 20px;*/
      top: 88px;
    }
  /deep/ .navbar-left-container2 {
    left: 30px;
  }
  .header a {
    white-space: nowrap;
  }
  .md-modal {
    width: 80%;
    left: 0;
    margin-left: 10%;
    margin-top: 0;
    top: 200px;
    position: absolute;
  }
  .md-modal .confirm-tips, .md-modal .alert-tips {
    padding: 10px 24px;
  }
  .regi_form_input{
    height: 35px;

  }
  .login-wrap {
    margin-top: 0;
  }
  .md-content .btn-login {
    font-size: 16px;
  }
  .regi_form_input .regi_login_input {
    height: 20px;
    margin-top: 7px;
    line-height: 20px;
    font-size: 12px;
  }

  /deep/ .navbar-left-container .home{
    display: block!important;
  }
  .navbar-search-pro{
    margin-left: 60px !important;
  }
  .navbar-cart-pro{
    display: none !important;
  }
  .showCart{
    display: block !important;
  }
}
 @media only screen and (min-width: 992px) and (max-width: 1256px) {
     .search-bar .search-input{
         width:600px;left: 159px;
     }
     .search-bar .search-icon {
         left: 171px;
     }
 }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue